import { isString } from "lodash";
import type { Remarkable } from "remarkable";
import { getMarkdownRenderer } from "./getMarkdownRenderer";

/**
 * Renders markdown text to HTML with adjusted heading levels.
 * Converts h1->h2, h2->h3, etc. to maintain document outline hierarchy.
 *
 * @param text - The markdown text to render
 * @param renderer - Optional Remarkable instance (defaults to the shared memoized one)
 * @param env - Optional render state handed to the renderer rules
 * @returns HTML string, or empty string if text is not a string
 */
export function markdown(
  text: string | undefined | null,
  renderer?: Remarkable,
  env?: Remarkable.Env,
): string {
  if (isString(text)) {
    return (
      (renderer ?? getMarkdownRenderer())
        .render(text, env)
        // convert <h1> to <h2> etc.
        .replace(
          /<(\/?)h([1-5])>/g,
          (_match, slash, number) => `<${slash}h${Number(number) + 1}>`,
        )
    );
  }
  return "";
}
